module.exports = __webpack_public_path__ + "static/media/irori_sm4.315be290.gif";